import { ThemeEvents } from '@theme/events';

class OonaProductTopRow extends HTMLElement {
  connectedCallback() {
    this.shippingAvailability = JSON.parse(this.querySelector('[data-shipping-availability]')?.textContent || '{}');
    this.productForm = this.closest('product-form');
    this.productForm?.addEventListener(ThemeEvents.variantUpdated, this.onVariantUpdated);
    this.productForm?.addEventListener('change', this.onOptionChanged);
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener(ThemeEvents.variantUpdated, this.onVariantUpdated);
    this.productForm?.removeEventListener('change', this.onOptionChanged);
  }

  onVariantUpdated = (event) => {
    this.updateShipping(event.detail.resource?.id);
  };

  // Le sélecteur d'angle utilise directement l'identifiant de variante.
  onOptionChanged = (event) => {
    if (event.target.matches('[data-product-angle][data-variant-id]:checked')) {
      this.updateShipping(event.target.dataset.variantId);
    }
  };

  updateShipping(variantId) {
    this.querySelectorAll('[data-shipping-badge]').forEach((badge) => {
      badge.hidden = this.shippingAvailability[variantId] !== true;
    });
  }
}

if (!customElements.get('oona-product-top-row')) {
  customElements.define('oona-product-top-row', OonaProductTopRow);
}
